/**
 * iter87 (Item X) - Single source of truth for how we introduce "Moment"
 * across Roam, Festivals, and Manifest.
 *
 * Founder rule: the FIRST time a user encounters "Moment" in any surface,
 * there's a one-line plain-language explanation of what it is. Every CTA
 * that starts a Moment - Roam destination, festival card, Manifest tab -
 * uses IDENTICAL language, identical flow, identical visual treatment.
 * A Moment is a Moment regardless of which surface surfaced the idea.
 */

// Exact copy — first-time explanation of the Assembly product (renamed
// from "Moments" on 2026-07-27 per founder decision, keeping this file's
// symbol name for internal stability).
export const MOMENT_TAGLINE =
  "Assemblies are how you coordinate real plans with people - trips, roommate searches, arrivals, meetups.";

// Every "start an assembly" button in the app renders THIS label. No variants.
export const START_MOMENT_LABEL = "Start an Assembly";
